import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { LogOut } from "lucide-react";

const NAV = [
  { to: "/admin", label: "Overview", end: true, testid: "admin-nav-overview" },
  { to: "/admin/crm", label: "CRM", testid: "admin-nav-crm" },
  { to: "/admin/site-copy", label: "Site copy", testid: "admin-nav-site-copy" },
  { to: "/admin/case-studies", label: "Case studies", testid: "admin-nav-case-studies" },
  { to: "/admin/services", label: "Services", testid: "admin-nav-services" },
  { to: "/admin/roster", label: "Logo roster", testid: "admin-nav-roster" },
  { to: "/admin/events", label: "Events", testid: "admin-nav-events" },
  { to: "/admin/clients", label: "Clients", testid: "admin-nav-clients" },
  { to: "/admin/frameworks", label: "Frameworks", testid: "admin-nav-frameworks" },
  { to: "/admin/field-notes", label: "Field Notes", testid: "admin-nav-field-notes" },
  { to: "/admin/scorecard", label: "Readiness Scorecard", testid: "admin-nav-scorecard" },
  { to: "/admin/packet", label: "Operating Room", testid: "admin-nav-packet" },
  { to: "/admin/audit", label: "Audit trail", testid: "admin-nav-audit" },
];

export function AdminLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  return (
    <div data-testid="admin-layout" className="cv-ui-scope cv-container py-10">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
        <aside className="lg:col-span-3">
          <p className="cv-kicker text-[#A6633C]">Admin</p>
          <p className="cv-body text-sm text-[#1F1B16]/70 mt-2">{user?.email}</p>
          <nav className="mt-6 flex flex-col gap-1">
            {NAV.map((n) => (
              <NavLink key={n.to} to={n.to} end={n.end} data-testid={n.testid}
                className={({ isActive }) => `cv-sans uppercase tracking-[0.12em] text-xs py-2.5 border-l-2 pl-3 transition-colors ${isActive ? "border-[#A6633C] text-[#1F1B16]" : "border-transparent text-[#1F1B16]/55 hover:text-[#1F1B16]"}`}>
                {n.label}
              </NavLink>
            ))}
            <NavLink to="/hub" className="cv-sans uppercase tracking-[0.12em] text-xs py-2.5 border-l-2 border-transparent pl-3 text-[#515E4F] hover:text-[#1F1B16]">The Hub</NavLink>
            <button data-testid="admin-logout" onClick={() => { logout(); navigate("/"); }} className="cv-sans uppercase tracking-[0.12em] text-xs py-2.5 pl-3 text-[#1F1B16]/55 hover:text-[#A65A43] inline-flex items-center gap-2 text-left"><LogOut size={13} /> Sign out</button>
          </nav>
        </aside>
        <main className="lg:col-span-9 min-h-[60vh]"><Outlet /></main>
      </div>
    </div>
  );
}
